export default {
    events: [],
    customTimeSlots: [],
    timeZones: [],
    userTimezone: null,
    timeSlots: [],
    availabilities: [],
    appointments: [],
    blockTime: 60,
}
